import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class BoardBackground extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'CustomBoardBackground';
  }
}
BoardBackground.initClass();

export { BoardBackground };
